ticket.ticketOddModule = {
    // Pridanie oddu na tiket
    ctAddOdd: function(oddID, betType) {
        try {
            // [Betbuilder Aggregator API] Ak je aktívny BetBuilder tab, presmeruj do BB logiky
            if (profile.BetBuilderAgg && betbuilderAgg?.state?.isTabActive === true) {
                // ak je betType == "betbuilder" tak sa jedna o pridanie multiodd z betbuilder agg api - finalny odd (pridanie na ticket, nie do zoznamu bb oddov)
                // ostatne oddy maju betType tak ako je definovany v onclick vratane tych pre betbuilder agg api
                if (betType !== "betbuilder") {
                    return betbuilderAgg.addOddToBetBuilder(oddID);
                    return false;
                }
            }
            
            if (more.asideLoading.inProgress) return; // Kontrola ci nie je spustene nejake schvalovanie tiketu
            if (event) event.stopImmediatePropagation();
            if (stored.actionsHandling.scrolledByTapAndHold) {
                stored.actionsHandling.scrolledByTapAndHold = false;
                return false;
            }
            // Pridanie odd-u na tiket zrusi pripadne otvoreny tooltip
            modal.hideTooltip();

            main.userAction();
            // Ak obsahuje prazdny odd (bez kurzu) alebo je kurz nevalidny (oddRate <= 1) tak zobrazi chybovu hlasku
            if (!oddID || $("#events #" + oddID + ", #event .chances #" + oddID).find("#crs").hasClass("no-crs")) {
                modal.showErrObj(2, 1, {err1: texts.OddErr, errType: "OddErr"});

            } else {
                // Pocas podavania / odoberania oddu zamkne tiket, tlacitko Submit ticketa Clear ticket
                main.lockSbmButtons();

                // Ak bol zvoleny odd uz oznaceny tak ho odstrani
                if (ticket.listCheck(oddID)) {
                    ticket.ticketOddModule.ctRemoveOdd(oddID);

                } else {
                    var odd = new Object();
                    odd.New, odd.Has, odd.E, odd.R, odd.D = odd.T1 = odd.T2 = odd.Tip = odd.TC = "", odd.L = false, odd.BB = false;
                    list.Sync++;

                    if (offer.eventID) {
                        // Pridanie oddu na tiket v ramci eventu - more chances

                        // Kontrola podpornosti - vrati ID podporneho oddu
                        var competitor = ticket.competitorCheck(oddID);

                        // Oznaci pridany odd v events
                        if (!competitor) {
                            $("#event .chances .ui-btn-up-e").addClass("ui-btn-up-e-hidden").removeClass("ui-btn-up-e");
                        } else if (competitor !== true) {
                            $("#event .chances #" + competitor).addClass("ui-btn-up-e-hidden").removeClass("ui-btn-up-e");
                        }
                        $("#event .chances #" + oddID).addClass("ui-btn-up-e");
                        if (profile.FlatCSS && profile.InlineDetailLeagueCups.includes(offer.eventLeagueCupID) && offer.inlineDetail) {
                            // Jedna sa o inline detail
                            $("#events .event-detail-inline #" + oddID).addClass("ui-btn-up-e");
                        }

                         // EventID
                        odd.E = offer.eventID;

                        // Ak sa jedna o LIVE event tak prida parameter L
                        if (offer.eventLive == "Y") odd.L = true;

                        if (profile.FlatCSS && profile.InlineDetailLeagueCups.includes(offer.eventLeagueCupID) && offer.inlineDetail) {
                            // Jedna sa o inline detail
                            var openedInlineVictoria = $("#" + oddID).closest(".virtual-event");
                            var openedInlineVictoriaAttrs = openedInlineVictoria.children().children();
                            odd.TS = openedInlineVictoriaAttrs.attr("sport-name");
                            odd.TR = openedInlineVictoriaAttrs.attr("region-name");
                            odd.TL = openedInlineVictoriaAttrs.attr("leagueCup-name");
                        } else {
                            // T! & T2 & TC & Date & Bet & Course - zaroven zvlast posklada pre Victoria Competitor
                            odd.TS = $("#event #chances").attr("sport-name");
                            odd.TR = $("#event #chances").attr("region-name");
                            odd.TL = $("#event #chances").attr("leagueCup-name");
                        } 
                        if ($("#event #chances").hasClass("victoria-competitor")) {
                            var longName = $("#event .chances #" + oddID).closest(".chance").find("h4 .name");
                            odd.T1 = longName.children("eventname").text();
                            odd.TC = longName.children("chanceTypeName").text();
                        } else {
                            if (profile.FlatCSS && profile.InlineDetailLeagueCups.includes(offer.eventLeagueCupID) && offer.inlineDetail) {
                                // Jedna sa o inline detail
                                odd.T1 = openedInlineVictoria.find(".ui-block-2").text();
                                odd.TC = $("#" + oddID).attr("chanceTypeName");
                            } else {
                                odd.T1 = $("#event #titleHome").text();
                                odd.T2 = $("#event #titleAway").text();
                                if (profile.BetBuilder && betType === "betbuilder") {
                                    odd.BB = "true";
                                    odd.TC = "";
                                } else {
                                    var chance = $("#event .chances #" + oddID).parents(".chance");
                                    if (odd.TC = $(chance).attr('chancetype-name')) {
                                        // ECT je zgrupena
                                        var groupedChanceType = true;
                                    } else {
                                        // Samostatna ECT
                                        odd.TC = $(chance).find("h4 .name").text();
                                    }
                                }
                            }
                        }
                        if (profile.FlatCSS && profile.InlineDetailLeagueCups.includes(offer.eventLeagueCupID) && offer.inlineDetail) {
                            // Jedna sa o inline detail
                            odd.Tip = $("#" + oddID).closest("tr").find(".competitor-name").text();
                            odd.D = openedInlineVictoria.attr("event-date");
                            odd.R = $("#" + oddID + " #crs").html();

                        } else {
                            if (betType === "betbuilder") {
                                odd.Tip += "";
                                odd.R = "";
                            } else {
                                if (groupedChanceType) {
                                    odd.Tip += $("#event .chances #" + oddID + " #tipNameNonGroup").html();
                                } else {
                                    odd.Tip += $("#event .chances #" + oddID + " #tipName").html();
                                }
                                odd.R = $("#event .chances #" + oddID + " #crs").html();
                            }
                            odd.D = $("#event #chances").attr("event-date");
                        }

                        // Zablokuje cely detail zapasu
                        $("#event .chances").addClass("lock-btn");

                    } else if (odd.New = $("#events #" + oddID).closest("[event-parent]")) {
                        // Pridanie oddu na tiket v ramci ponuky - ak sa v nej nenachadza tak sa stuktura nenaplni

                        // Zisti poradie bloku detailu zapasu
                        var detailBlock;
                        if (stored.ExtendedActualOffer) {
                            // Zahrna eventsSexta (okrem viktoriek)
                            if (profile.VirtualsOctava && (offer.regionID === 1239 && offer.provider === offer.providerNameUOF)) {
                                detailBlock = 12;
                            } else {
                                detailBlock = 9;
                            }
                        } else {
                            detailBlock = 5;
                        }

                        odd.E = parseInt(odd.New.find(".ui-block-" + detailBlock + " a").attr("ID"));
                        // Ak sa jedna o LIVE event tak prida parameter L
                        if (odd.New.find(".ui-block-1 a").hasClass("is-live")) odd.L = true;

                        // Date
                        odd.D = odd.New.attr("event-date");

                        // SportName | RegionName | LeagCupName
                        odd.TS = odd.New.find("[sport-name]").attr("sport-name");
                        odd.TR = odd.New.find("[region-name]").attr("region-name");
                        odd.TL = odd.New.find("[leagueCup-name]").attr("leagueCup-name");

                        // T1 & T2
                        if (stored.ExtendedActualOffer) {
                            odd.T1 = $(odd.New.find(".ui-block-2 .ui-li-desc .team-name")[0]).text();
                            odd.T2 = $(odd.New.find(".ui-block-2 .ui-li-desc .team-name")[1]).text();
                        } else {
                            odd.T1 = odd.New.find(".ui-block-2 .ui-li-desc").text();
                            odd.T2 = odd.New.find(".ui-block-4 .ui-li-desc").text();
                        }

                        // odd.TC
                        if (offer.regionID === 1239 && offer.provider === offer.providerNameUOF && stored.ExtendedActualOffer) {
                            // Jedna sa o zapas vo virtualnom futbale s inymi nez len masterChanceTyp-ami v liste
                            odd.TC = $("#events #" + oddID).attr("chancetype-name");
                        } else {
                            odd.TC = odd.New.attr("chancetype-name");
                        }

                        // Bet
                        odd.Tip = $("#events #" + oddID).attr("tip-name");
                        if (!odd.Tip || odd.Tip === "") odd.Tip = $("#events #" + oddID).attr("tip-type");
                        
                        // Course
                        odd.R = $("#events #" + oddID + " #crs").html();
                    }

                    if (offer.eventID) {
                        odd.New = $("#eventsOfDay .event-of-day#" + offer.eventID);
                    } else if ($("#eventsOfDay #" + oddID).length) {
                        odd.New = $("#eventsOfDay #" + oddID).parents(".event-of-day");
                    }

                    if (odd?.New.length) {
                        // Dany event sa nachadza aj v zapasoch dna na home obrazovke
                        var tipFromHomePage = $("#eventsOfDay #" + oddID);

                        // Odznacenie ostatnych oddov v danom zapase
                        odd.New.find('a').removeClass('ui-btn-up-e');

                        if (tipFromHomePage.length) {
                            odd.D = $(odd.New).attr('event-date');
                            odd.E = $(odd.New).attr('id');
                            odd.T1 = $(odd.New.find(".team-name")[0]).text();
                            odd.T2 = $(odd.New.find(".team-name")[1]).text();
                            odd.R = tipFromHomePage.text();
                            odd.TC = $(odd.New).attr('chancetype-name');
                            odd.TL = $(odd.New).attr('league-name');
                            odd.TR = $(odd.New).attr('region-name');
                            odd.TS = $(odd.New).attr('sport-name');
                            odd.Tip = tipFromHomePage.attr('tip-team-name')
                            odd.TipFromHomePageSportID = $(odd.New).attr('sport-id');
                            // Oznacenie oddu ktory ma byt pridany na tiket
                            tipFromHomePage.addClass("ui-btn-up-e");
                        }
                    }

                    // Ak nie je vytvorena struktura oddu tak sa obsah tiketu aktualizuje az po Synchronizacii
                    if (offer.eventID || odd?.New.length) {

                        // Zablokuje prematch aj live event v ponuke pokial neprejde sync
                        $("#events #M" + odd.E + " fieldset").addClass("lock-btn");

                        // Kontrola viacerych oddov v ramci jedneho eventu
                        if ((competitor === true) || list.Events.indexOf(String(odd.E)) == -1) {
                            odd.Has = false;
                        } else {
                            // Ak existuje odd v ramci toho isteho eventu a nejedna sa o dovolenu podpornost tak ho na tikete skryje, po sync zmaze
                            if (competitor) {
                                // VICTORIA_COMPETITOR - jeden odd sa ma odstranit
                                odd.Has = competitor;
                                $("#ticketList #" + odd.Has).hide().parent(".group").hide();
                            } else {
                                // Kazda bezna chancetype alebo VICTORIA_PLAYER - vsetky oddy eventu sa maju odstranit
                                odd.Has = true;
                                $("#ticketList .EVT-" + odd.E).hide().parent(".group").hide();
                            }
                        }

                        // Odstrani povodne oznaceny odd pre dany event
                        $("#events #M" + odd.E + " .ui-btn-up-e").addClass("ui-btn-up-e-hidden").removeClass("ui-btn-up-e");

                        if (profile.FlatCSS && profile.InlineDetailLeagueCups.includes(offer.eventLeagueCupID) && offer.inlineDetail) {
                            // Oznaci dany odd v inline detaile
                            $("#events #M" + odd.E + " #" + oddID).addClass("ui-btn-up-e");

                            $("#events #" + odd.E).addClass("ui-btn-up-e");
                        } else {
                            // V Ponuke oznaci sipku (more chances) ak sa nejedna o zakladne DUO/TRIO (SEXTA)
                            if (!$("#events #M" + odd.E + " #" + oddID).addClass("ui-btn-up-e").length) $("#events #" + odd.E).addClass("ui-btn-up-e");
                        }

                        // Vytvori docasny datovy objekt tiketu
                        var dataTemp = new Object(),
                            nextGroup = "A";

                        // Nastavi pismeno nasledujucej skupiny pre kombi tiket doplni TYPE do dataTemp
                        if (ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) {
                            if ($("#ticketList li").length)
                                if (!odd.Has) {
                                    nextGroup = String.fromCharCode($("#ticketList .group-name:last").text().charCodeAt(0) + 1);
                                } else {
                                    nextGroup = $("#ticketList .group-name:last").text();
                                }
                            // Ak je nextGroup null
                            if (nextGroup === "\x00") nextGroup = "";
                            // Ak bola jedina skupina samotna tutovka
                            if (!odd.Has && !nextGroup || nextGroup == "2") nextGroup = "A";
                            dataTemp.TYPE = ticket.state.ticketWsTypes.SRT;
                        } else {
                            dataTemp.TYPE = ticket.state.ticketWsTypes.JT;
                        }

                        // Overi a upravit chanceType name pre tiket
                        var chanceTypeName = odd.TC;
                        // TODO - tu preblikava chancetype "Zápas - Víťaz" pri tom kym dostanem data z WS
                        // TODO - pre stavku na vitaza (dostihy) by to nemalo platit
                        if (!(/ - /).test(chanceTypeName)) chanceTypeName = texts.OfferMatch + " - " + chanceTypeName;

                        try {
                            // Vytvori Data Object
                            dataTemp.Odds = JSON.parse('[{"OddID":"' + oddID
                                + '", "SportID":"' + (odd.TipFromHomePageSportID? odd.TipFromHomePageSportID : offer.SeSpID)
                                + '", "SportName":"' + odd.TS.replace(/"/g, '\'')
                                + '", "RegionName":"' + odd.TR.replace(/"/g, '\'')
                                + '", "LeagueCupName":"' + odd.TL.replace(/"/g, '\'')
                                + '", "Team1":"' + odd.T1.replace(/"/g, '\'')
                                + '", "Team2":"' + odd.T2.replace(/"/g, '\'')
                                + '", "ChanceType":"' + chanceTypeName.replace(/"/g, '\'')
                                + '", "EVT":"' + odd.E
                                + '", "DATE":"' + odd.D
                                + '", "Tip":"' + odd.Tip
                                + '", "Rate":"' + odd.R
                                + '", "RateTicket":"' + odd.R
                                + '", "LiveBet":' + odd.L
                                + ', "IsActive":' + true
                                + ', "Group":"' + nextGroup + '"}]');

                            // Vyrenderuje odd na tikete
                            ticket.ticket(dataTemp, oddID, null, null, odd.Has);
                        } catch (e) {
                            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
                        }

                        // Aktualizuje pocet odds na tikete
                        if (!odd.Has) list.Count++;
                        $(".ticket-header__item--tips .ticket-header__value").text(list.Count);
                    }

                    // Synchronizuje so serverom
                    modal.showLoading();

                    try {
                        var requestUrl;
                        $.getJSON(requestUrl = url.ticket + "ticket/SBID_" + stored.SBID + "/oddadd/" + oddID + "/" + ticket.ticketOddModule.setLogOdd())
                            .done(function (data) {
                                if (data === Object(data)) {
                                    ticket.ticketOddModule.ctAddOddDone(oddID, odd, data);
                                    // Zatvori event okno
                                    eventDetail.autoCloseEvent(betType);
                                } else {
                                    // NO DATA -> TICKET RETRIEVE | CLEAR | RESET
                                    ticket.ticketOddModule.ctAddOddFail(oddID, odd, true);
                                }
                            })
                            // Ak addOdd zlyha pri sync tak sa da rollback
                            .fail(function (jqXHR) {
                                jqXHR.requestUrl = requestUrl;
                                ticket.ticketOddModule.ctAddOddFail(oddID, odd);
                            })
                            .always(function (data) {
                                events.unlockEvent(oddID, odd.E);
                                // Zobrazi pripadne error hlasky
                                if (data) {
                                    var errors = modal.parseErrors(data.Errors, data.MaxBetReason);
                                    modal.showErrObj(2, 5, {errObj: errors});
                                }
                                modal.hideLoading();
                            });
                    } catch (e) {
                        console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
                        events.unlockEvent(oddID, odd.E);
                    }

                    // Ak nebezi refresh tiketu tak schova napovedu
                    if (!rfs.ticket && list.Odds.length) {
                        $("#ticketHelp").hide();
                        ticket.stopMarkingHelp();
                    }
                }
            }

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            ticket.ticketWsRetrieve(true);
            events.unlockEvent(oddID, odd.E);
            return true;
        }
    },

    // Pridanie oddu na tiket uspesne
    ctAddOddDone: function(oddID, odd, data, isOddsList) {
        try {
            if (oddID && data) {

                // Nastavi dlzku oneskorenia pri prijme tiketu
                ticket.state.setState({liveBetDelayMs: data.LiveBetDelayMs, isLotteryTicket: data.IsLotteryTicket, type: data.TYPE});
                ticket.ticketTypeSwitch(data.TYPE, !ticket.state.isTicketWsType(data.TYPE));

                if (odd && !isOddsList) {
                    // Odstrani oznacenie buttonov
                    $("#events #M" + odd.E + " .ui-btn-up-e-hidden").removeClass("ui-btn-up-e-hidden");
                    if (offer.eventID) $("#event .chances .ui-btn-up-e-hidden").removeClass("ui-btn-up-e-hidden");
                    list.Sync && list.Sync--;
                    if (odd.Has)
                        if (odd.Has === true) {
                            var i = -1;
                            for (e = 0; e < list.Events.length; e++) {
                                if (!stored.submitting && (i = list.Events.indexOf(String(parseInt(odd.E)))) != -1) {
                                    list.Odds.splice(i, 1);
                                    list.Events.splice(i, 1);
                                    e++;
                                }
                            }
                        } else {
                            ticket.listCheck(odd.Has, null, "update");
                        }
                    // Pri zlatej lige a neprihlasenom hracovi alebo manualne overenom hracovi upozorni na nutnost sa prihlasit
                    if (!profile.GoldenLeagueBlocked && (!stored.PlayerID || stored.PlayerID === profile.ManualVerifiedPlayerID) && offer.SeSpID === 0) modal.showErrObj(3, 5, {err1: texts.OfferGoldenLeagueLogin, errType: "OfferGoldenLeagueLogin"});
                } else if (odd && isOddsList) {
                    list.Sync--;
                }
                // Aktualizuje odd/s voci serveru
                if (data.Odds) {

                    if (list.Sync) {
                        // Ak este prebieha niektory Sync tak len aktualizuje prave pridany Odd
                        ticket.ticket(data, oddID, null, true);
                    } else {
                        // Ak sa jedna o posledny Sync tak nanovo vyrenderuje tiket, aktualizuje pocet odds a oznaci ich v ponuke
                        ticket.ticket(data, null, true, true);

                        // Pridanie oddu pocas zobrazenych mojich tiketov - prejde na predchadzajuce zobrazenie JT/SRT
                        if (ticket.state.getState().actualTab === ticket.state.ticketTabs.MT) {
                            ticket.ticketTypeSwitch(ticket.state.getState().type);
                        }
                        // Nastavenie limitov a maximalneho vkladu
                        var hint = [], errContainer = [];
                        if (!(errContainer = ticket.setMinMaxBet(data.MinBet, data.MaxBet, data.MaxBetReason, data.PossibleGrossBet, data.OverallTotalBet, data.IsEdited)).length) {
                            // Kontrola BoosterBonusu (dostupne len pre jednoduchy tiket) - ticket.ticketPromoModule.parseBoosterBonus(data, {pocet oddov do zobrazenia hintu})
                            if (profile.BoosterBonus && !ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT) && (hint = ticket.ticketPromoModule.parseBoosterBonus(data.BoosterBonusHint, 2))[0]) {
                                if (stored.OverallTotalBet && profile.BoosterBonusName === "Booster") {
                                    if (texts.BoosterBonusHint[0]) {
                                        errContainer[0] = texts.BoosterBonusHint[0];
                                        if (hint[1]) {
                                            if (hint[1][1])
                                                errContainer[0] += " " + hint[1][1];
                                            if (texts.BoosterBonusHint[1] && texts.BoosterBonusHint[2])
                                                errContainer[1] = texts.BoosterBonusHint[1] + " " + hint[0] + " " + texts.BoosterBonusHint[2];
                                            if (hint[1][0] && texts.BoosterBonusHint[3])
                                                errContainer[1] += " " + texts.BoosterBonusHint[3] + " " + parseFloat(hint[1][0]).toFixed(2);
                                        }
                                    }
                                }
                            }
                        }
                        modal.showErrObj(2, 5, {err1: errContainer[0], err2: errContainer[1], errType: "default"});
                        modal.hideLoading();
                    }
                    // GA4 - trackovanie pridania oddu na ticket - sporty a virtualky
                    var currentOdd = data.Odds.find(function (item) { return item.OddID == oddID });

                    if (currentOdd) {
                        gtag('event', 'add_to_cart', {'items': [{
                            'item_id': data.TYPE,
                            'item_category': currentOdd.SportName,
                            'item_category2': currentOdd.RegionName,
                            'item_category3': currentOdd.LeagueCupName,
                            'item_list_name': offer.page,
                        }]});
                    }

                } else {
                    // Ak server vrati prazdne odds tak sa vymaze cely tiket
                    ticket.ticketCheck("clear");
                }

                return true;
            } else {
                // Rollback
                if (isOddsList) {
                    ticket.ticketWsRetrieve(true);
                } else {
                    ticket.ticketOddModule.ctAddOddFail(oddID, odd, true);
                }
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            // Rollback
            if (isOddsList) {
                ticket.ticketWsRetrieve(true);
            } else {
                ticket.ticketOddModule.ctAddOddFail(oddID, odd, true);
            }
            return false;
        }
    },

    // Funkcia na nastavenie logu pre addOdd
    setLogOdd: function() {
        try {
            var logOdd = "";
            if (offer.page) {
                logOdd = offer.page;
                if (offer.page != "virtualGames") {
                    if (offer.regionID != -1) {
                        if (offer.leagueCupID != -1) {
                            logOdd += "_L";
                        } else {
                            logOdd += "_R";
                        }
                    } else {
                        logOdd += "_S";
                    }
                }
                if (offer.eventID) logOdd = logOdd + "_E";
                if (offer.top == -1) logOdd = logOdd + "_ALL";
                if (offer.homeButtonUsed) logOdd = logOdd + "_HB";
            }
            if (profile.ConsoleLog || profile.ConsoleLog$.Ticket) console.log("$$$ Ticket - source: " + logOdd);
            return logOdd;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia odobere z tiketu exspirovane oddy
    removeOddsExp: function() {
        try {
            event.stopPropagation();
            main.userAction();

            if (list.OddsExpired.length) {
                if (ticket.state.getState().isLotteryTicket) {
                    // TODO: kuro odstranovanie viac oddov naraz
                    for (o = 0; o < list.OddsExpired.length; o++) {
                        setTimeout(function(o) {
                            // Triggerne priamo DOM element ktory obsahuje funkcie potrebne pre ticket.ticketLotteryModule.ctRemoveOddLottery(...args)
                            $("#" + list.OddsExpired[o] + " #removeOdd").trigger("mousedown");
                        }, 200, o);
                    }
                } else {
                    // TODO: kuro odstranovanie viac oddov naraz
                    for (o = 0; o < list.OddsExpired.length; o++) {
                        ticket.ticketOddModule.ctRemoveOdd(list.OddsExpired[o]);
                    }
                }
            }
            modal.hideErr(true);
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia pridava/odobera oddy z listu expirovanych oddov
    addRemoveOddFromList: function(odd) {
        try {
            switch (odd.BetStatus) {
                case "EXP":
                case "SUS":
                    if (!stored.IsEdited && !list.OddsExpired.includes(odd.OddID) && list.Odds.includes(odd.OddID)) {
                        // (Len rezim v ktorom sa needituje tiket) Neaktualny odd sa nenachadza v OddsExpired a sucasne je pridany na tikete
                        list.OddsExpired.push(odd.OddID);
                    }
                    break;
                case "ACT":
                    list.OddsExpired = list.OddsExpired.filter(function(oddExpired) {
                        return oddExpired !== odd.OddID;
                    });
                    break;
                default:
                    break;
            }
        
            if (stored.submitting) {
                switch (stored.AllowedRateChange) {
                    case "Up":
                        if (odd.Desc === "D") {
                            // Novy kurz je nizsi ako povodny
                            if (!list.OddsRateChanged.includes(odd.OddID)) {
                                list.OddsRateChanged.push(odd.OddID);
                            }
                        }
                        break;
                    case "None":
                        if (odd.Desc === "D" || odd.Desc === "U") {
                            if (!list.OddsRateChanged.includes(odd.OddID)) {
                                list.OddsRateChanged.push(odd.OddID);
                            }
                        }
                        break;
                    case "All":
                    default:
                        break;
                }
            }
        } catch(e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funckia aktualizuje odd v ramci tiketu
    oddChangedTicket: function(odd) {
        try {
            // Odstranenie oddu z tiketu
            t = $("#ticketList #" + odd.OddID);
            if (odd.BetStatus === "EXP") {
                // Nastavi odd popripade tabulku vyhernosti (loteria) pre dany odd ako disablovanu
                t.children().removeClass("highlight").addClass("ui-disabled").end().next(".ticket-table-lottery-wrapper").addClass("ui-disabled");
            } else {
               // Aktualizuje hodnoty titleHome, titleAway, titleChanceType, date, bet
               var arrow = "";
               if (odd.SportName && odd.RegionName && odd.LeagueCupName) {
                   var divider = " | ";
                   if (profile.FlatCSS) divider = " - ";
                   t.find("#titleRegion").text(odd.SportName + divider + odd.RegionName + divider + odd.LeagueCupName);
               }
               t.find("#titleHome").text(odd.Team1);
               t.find("#titleAway").text(odd.Team2);
               if (profile.BetBuilderAgg && odd.IsBetbuilder) {
                   // [Betbuilder Aggregator API]  "ChanceType": "Zápas - Výsledok (Riadny hrací čas) | 1 && Zápas - Strelec gólu (Riadny hrací čas) | Gól"
                   t.find("#titleChanceType").html(betbuilderAgg.formatAggregatorChanceType(odd.ChanceType));
               } else if (profile.BetBuilder && odd.IsBetbuilder && !odd.ChanceType.includes(" | ")) {
                   t.find("#titleChanceType").html('<div>' + odd.ChanceType.replace(/ && /g, '</div><div>') + '</div>');
               } else {
                   t.find("#titleChanceType").text(odd.ChanceType);
               }
               t.find("#date").text(odd.DATE);
               t.find("#bet").text(odd.Tip);

               // Update delty kurzov na tikete
                if (!t.hasClass("odd-edited")) {
                    // Ak sa nejedna o uz podany odd pri editacii tiketu
                    if (odd.Rate) {
                        var arrow = "";
                        var tRate = $(t.find("#crsOriginal")).text();
                        if (tRate != odd.Rate) {
                            // Porovna deltu s kurzom na tikete a aktualizuje ho
                            if (tRate > odd.Rate) {
                                arrow = "ArrD";
                            } else if (tRate < odd.Rate) {
                                arrow = "ArrU";
                            }
                            // Aktualizuje kurz a prida sipku
                            t.find("#crsOriginal").text(odd.Rate.toFixed(2)).removeClass().addClass(arrow);

                            // Zhasne sipku po urcitom case
                            events.eventsSignalrModule.hideArrow("T_" + odd.OddID, "#ticketList #" + odd.OddID, "#crsOriginal");
                        }
                    }
                }

               // Odomknutie oddu na tikete
               if (odd.BetStatus === "ACT") {
                   t.children().removeClass("highlight ui-disabled"); // t.removeAttr("onclick");
               }
               // Zamknutie oddu na tikete
               else if (odd.BetStatus === "SUS") {
                   t.children().removeClass("highlight").addClass("ui-disabled"); // t.attr("onclick","removeOdd("+odd.O+")");
               }
            }
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Ak addOdd zlyha pri sync tak sa da rollback
    ctAddOddFail: function(oddID, odd, retrieve) {
        try {
            main.createLog(2, "CentralTicketAddOdd_Failed", "ODD: " + oddID);
            if (retrieve) ticket.ticketWsRetrieve(true);
            if (oddID) {
                if (list.Sync) {
                    // Odstrani novo pridany odd
                    ticket.listCheck(oddID, null, "remove", retrieve);
                    // Ak mal predtym oznaceny odd, tak ho oznaci nazad
                    if (odd && odd.Has) {
                        list.Count++;
                        $("#events #M" + odd.E + " .ui-btn-up-e-hidden").removeClass("ui-btn-up-e-hidden").addClass("ui-btn-up-e");
                        if (offer.eventID) $("#event .chances .ui-btn-up-e-hidden").removeClass("ui-btn-up-e-hidden").addClass("ui-btn-up-e");
                        $("#ticketList .EVT-" + odd.E).removeAttr("style").parent(".group").removeAttr("style");
                    }
                }
            }
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Odobranie oddu z tiketu // data.IsLotteryTicket
    ctRemoveOdd: function(oddID, eventID, chancetypeID, leagueCupID, isLottery) {
        try {
            if (event) event.stopImmediatePropagation();
            if (stored.actionsHandling.scrolledByTapAndHold) {
                stored.actionsHandling.scrolledByTapAndHold = false;
                return false;
            }
            if (isLottery) {
                ticket.ticketLotteryModule.ctRemoveOddLottery(oddID, eventID, chancetypeID, leagueCupID);
                return true;
            }

            modal.showLoading();
            main.lockSbmButtons();
            // Docasne skryje odd na tikete
            if (!ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) {
                $("#ticketList #" + oddID).hide();
            }
            // Odznaci odd a zamkne dany event v ponuke
            $("#events #" + oddID).removeClass("ui-btn-up-e").parents("fieldset").addClass("lock-btn");
            // Odznaci odd a zablokuje event na home obrazovke
            $("#eventsOfDay #" + oddID).removeClass("ui-btn-up-e").parents('.event-of-day').addClass("lock-btn");
            if (list.Count) $(".ticket-header__item--tips .ticket-header__value").text(list.Count - 1);

            var eventID = offer.eventID, requestUrl;
            $.getJSON(requestUrl = url.ticket + "ticket/SBID_" + stored.SBID + "/oddremove/" + oddID)
                .done(function (data) {
                    if (data === Object(data)) {
                        ticket.ticketOddModule.ctRemoveOddDone(oddID, data);
                    } else {
                        ticket.ticketOddModule.ctRemoveOddFail(oddID);
                    }
                })
                .fail(function (jqXHR) {
                    jqXHR.requestUrl = requestUrl;
                    // NO DATA -> TICKET RETRIEVE | CLEAR | RESET
                    ticket.ticketOddModule.ctRemoveOddFail(oddID, true);
                })
                .always(function () {
                    // Odomkne event a chance
                    events.unlockEvent(oddID, eventID);
                });

            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            ticket.ticketOddModule.ctRemoveOddFail(oddID);
            events.unlockEvent(oddID, eventID);
            return false;
        }
    },

    // Odobranie oddu z tiketu uspesne
    ctRemoveOddDone: function(oddID, data) {
        try {
            if (oddID && data) {
                if (data.Odds.length) {
                    var errContainer = [];
                    if ((data.Errors && !data.Errors.length) || (ticket.state.getState().isEditTicket && data.Errors && data.Errors.length)) {
                        if (ticket.state.getState().isEditTicket) {
                            // Ak z nestadnardneho dovodu prejde odstranenie oddu na tiketovu sluzbu, tak zobrazi error a prerendruje oddy nastavene na ticket ws
                            errContainer = modal.parseErrors(data.Errors, data.MaxBetReason);
                            modal.showErrObj(2, 5, {errObj: errContainer});
                        }
                        // Zmaze odd z listu exspirovanych oddov
                        list.OddsExpired = list.OddsExpired.diff([oddID]);
                        // Zmaze odd z listu
                        ticket.listCheck(oddID, null, "remove");
                        // Prerenderuje tiket
                        ticket.ticket(data, null, true, true);
                        // Aktualizuje zoznam expirovanych oddov
                        list.OddsExpired = list.OddsExpired.interSection(list.Odds);
                        // Aktualizuje zoznam expirovanych oddov ktore boli skryte
                        list.OddsExpiredHidden = list.OddsExpired.interSection(list.OddsExpiredHidden);
                        // Nastavenie limitov a maximalneho vkladu
                        errContainer = ticket.setMinMaxBet(data.MinBet, data.MaxBet, data.MaxBetReason, data.PossibleGrossBet, data.OverallTotalBet, data.IsEdited);
                        modal.showErrObj(2, 5, { err1: errContainer[0], err2: errContainer[1]});

                    } else {
                        errContainer = modal.parseErrors(data.Errors, data.MaxBetReason);
                        modal.showErrObj(2, 5, {errObj: errContainer});
                    }

                    // Nastavi dlzku oneskorenia pri prijme tiketu
                    ticket.state.setState({liveBetDelayMs: data.LiveBetDelayMs});

                } else {
                    // Bol odstraneny posledny odd na tikete
                    ticket.ticketCheck("clear");
                }

                return true;
            } else {
                ticket.ticketOddModule.ctRemoveOddFail(oddID, true);
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            ticket.ticketOddModule.ctRemoveOddFail(oddID, true);
            return false;
        }
    },

    // Odobranie oddu z tiketu neuspesne
    ctRemoveOddFail: function(oddID, retrieve) {
        try {
            main.createLog(2, "CentralTicketRemoveOdd_Failed", "ODD: " + oddID);
            if (retrieve) ticket.ticketWsRetrieve(true);
            if (oddID) {
                if (!ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) {
                    $("#ticketList #" + oddID).removeAttr("style");
                } else {
                    $("#ticketList #" + oddID).parent().removeAttr("style");
                }
                $("#events *#" + oddID).addClass("ui-btn-up-e");
                $("#eventsOfDay #" + oddID).addClass("ui-btn-up-e");
                $("#ticketList #" + oddID).removeAttr("style");
                $(".ticket-header__item--tips .ticket-header__value").text(list.Count);
            }
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    }
};
